import type { AlertLevel } from '@sentinel/shared';

interface BrandMarkProps {
  size?: number;
  /** Alert level of the active operation: the node of the mark is the only place it lives. */
  level?: AlertLevel | undefined;
}

const LEVEL_FILL: Record<AlertLevel, string> = {
  green: 'var(--lv-v-fill)',
  yellow: 'var(--lv-g-fill)',
  orange: 'var(--lv-a-fill)',
  red: 'var(--lv-r-fill)',
};

/** The Sentinel mark (design system §01): ring + node + four ticks. Radius 26% is reserved to it. */
export function BrandMark({ size = 26, level }: BrandMarkProps) {
  const nodeFill = level === undefined ? 'var(--mark-node)' : LEVEL_FILL[level];
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} fill="none" aria-hidden="true">
      <rect
        x="11"
        y="11"
        width="42"
        height="42"
        rx="11"
        stroke="var(--mark-ring)"
        strokeWidth="4.2"
      />
      <circle cx="32" cy="32" r="6.5" fill={nodeFill} />
      <path
        d="M32 3.5V11M32 53v7.5M3.5 32H11M53 32h7.5"
        stroke="var(--mark-ring)"
        strokeWidth="4.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
